<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="pt-5 py-lg-5 feedback-container">
    <div class="row justify-content-center me-0">
        <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
            <img class="feedback-image" src="./assets/img/FeedBackManos.png" width="500" height="320" priority
                alt="Ilustración de dos manos estrechándose en señal de acuerdo." />

            <h2 class="feedback-title mb-4">¡Aquí estaremos cuando tú <br> estés listo!</h2>
            <p class="feedback-subtitle mb-4">
                Te enviaremos un correo con todo lo que necesitas saber de nuestro Seguro de Arriendo.
            </p>

            <button type="button" class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mt-lg-0 mt-3 mb-5">
                Entendido.
            </button>
        </div>
    </div>
</div>

<app-footer-app></app-footer-app>